<template>
  <div class="dicom-upload-main-container">
    <div class="section-holder">
      <div class="title-text">扫描二维码添加，或直接粘贴报告链接</div>
      <div class="report-holder">
        <div class="report-input-area">
          <textarea
            v-model="dicomInfo.fileUrl"
            class="link-input"
            style="width: 100%; height: 100%"
            placeholder="粘贴报告链接"
          />
        </div>
        <div class="scan-button" @click="openQaScan">
          <img
            src="https://staff.chunyu.mobi/@/media/images/2022/09/14/89f6/685c69e80f01_w48_h48_.png"
            class="button-icon"
          />
          <span class="button-text">
            扫码快速添加
          </span>
        </div>
      </div>
    </div>
    <div class="section-holder">
      <div class="title-text">打开报告是否需要验证信息？</div>
      <div class="choose-button-holder" @click="switchVerify(true)">
        <img
          v-show="needVerifyInfo"
          class="choose-icon"
          src="https://staff.chunyu.mobi/@/media/images/2022/09/14/8559/c099ec550dab_w60_h60_.png"
        />
        <img
          v-show="!needVerifyInfo"
          class="choose-icon"
          src="https://staff.chunyu.mobi/@/media/images/2022/09/14/22ec/33bacd98e9db_w60_h60_.png"
        />
        <span class="choose-button-title">是</span>
        <span class="choose-button-text">(验证信息仅您和医生可见)</span>
      </div>
      <div v-show="needVerifyInfo" class="report-holder">
        <div class="report-input-area">
          <textarea
            v-model="dicomInfo.verifyCode"
            class="link-input"
            style="width: 100%; height: 100%"
            placeholder="输入验证信息"
          />
        </div>
      </div>
      <div
        class="choose-button-holder margin-top no-margin-bottom"
        @click="switchVerify(false)"
      >
        <img
          v-show="!needVerifyInfo"
          class="choose-icon"
          src="https://staff.chunyu.mobi/@/media/images/2022/09/14/8559/c099ec550dab_w60_h60_.png"
        />
        <img
          v-show="needVerifyInfo"
          class="choose-icon"
          src="https://staff.chunyu.mobi/@/media/images/2022/09/14/22ec/33bacd98e9db_w60_h60_.png"
        />
        <span class="choose-button-title">否</span>
      </div>
    </div>
    <div class="bottom-button-holder">
      <div class="bottom-button" @click="uploadDicom">
        确认
      </div>
    </div>
  </div>
</template>
<script>
import * as cyDetect from '@cy/detect';
import cyShare from '@cy/share';
import NativeBridge from '@cy/native-bridge'; // app协议库
import { doPoint } from '@/utils/index';
import {
  uploadDicomForQaRequest,
  uploadDicomForReportRequest,
} from '../../services/index.js';

const wx = require('weixin-js-sdk');

export default {
  name: 'DicomUpload',
  data() {
    return {
      needVerifyInfo: true,
      urlData: {
        fromType: '', // qa or report
        problemId: '',
      },
      dicomInfo: {
        fileUrl: '',
        verifyCode: '',
      },
      environment: '', // wx or app or browser
      toastObj: {},
    };
  },
  created() {
    const { from_type, problem_id } = this.$route.query;
    this.urlData.fromType = from_type || 'default';
    this.urlData.problemId = problem_id || '';
    this.environment = this.getEnvironment();
    console.log(this.environment);
    window.cyOnScanResult = res => {
      this.dicomInfo.fileUrl = res.content;
      console.log(this.dicomInfo);
    };
  },
  methods: {
    showToast(txt) {
      this.toastObj = this.$createToast({
        txt,
        mask: false,
        type: 'txt',
        time: 1500,
      });
      this.toastObj.show();
    },
    switchVerify(bool) {
      this.needVerifyInfo = bool;
    },
    uploadDicom() {
      let invalidText = '';
      if (!this.dicomInfo.fileUrl) {
        invalidText = '请上传报告链接';
      } else if (this.needVerifyInfo && !this.dicomInfo.verifyCode) {
        invalidText = '请输入验证信息';
      }
      if (invalidText) {
        this.showToast(invalidText);
        return;
      }
      if (this.urlData.fromType === 'qa') {
        uploadDicomForQaRequest({
          problem_id: this.urlData.problemId,
          from_wx_mini: 1,
          partner: 'chunyu_wap_mini',
          content: JSON.stringify([
            {
              type: 'dicom',
              file: this.dicomInfo.fileUrl,
              verify_code: this.dicomInfo.verifyCode,
            },
          ]),
        })
          .then(res => {
            console.log(res);
            if (res.error === 0) {
              this.uploadComplete();
            } else {
              this.showToast('上传失败');
            }
          })
          .catch(err => {
            this.showToast(err.error_msg);
          });
      } else if (this.urlData.fromType === 'report') {
        const dicomData = [
          {
            url: this.dicomInfo.fileUrl,
            resource_name: '医学影像文件',
            resource_type: 'dicom',
            resource_size: '',
            remark: '',
            verify_code: this.dicomInfo.verifyCode,
          },
        ];
        uploadDicomForReportRequest({
          task_id: this.urlData.problemId,
          related_images: JSON.stringify(dicomData),
          is_append: true,
        }).then(res => {
          console.log(res);
          if (res.error_code === 0) {
            this.uploadComplete();
          }
        });
      }
    },
    openQaScan() {
      console.log(this.environment);
      if (this.environment === 'browser') {
        this.toastObj = this.$createToast({
          txt: '暂不支持扫码，请用手机打开',
          mask: false,
          type: 'txt',
          time: 1000,
        });
        this.toastObj.show();
      } else if (this.environment === 'wx') {
        cyShare
          .signWeixinJsSdk('/publicwap/wx_js_sdk_sign/?url=', {
            debug: false,
            jsApiList: ['scanQRCode'],
          })
          .then(() => {
            wx.scanQRCode({
              needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
              scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
              success: res => {
                console.log(res);
                this.dicomInfo.fileUrl = res.resultStr;
              },
            });
          })
          .catch(err => {
            console.log(err);
          });
      } else if (this.environment === 'app') {
        console.log('this is app');
        const params = {
          on_success: 'cyOnScanResult',
          new_win: false,
        };
        NativeBridge.qrScan('1.0', JSON.stringify(params));
      }
    },
    getEnvironment() {
      if (cyDetect.isFromCYAll()) {
        return 'app';
      }
      if (cyDetect.isFromWechat()) {
        return 'wx';
      }
      return 'browser';
    },
    uploadComplete() {
      const trackData = {
        click_position: '提交',
        page_readable_name: '医学影像上传',
      };
      if (this.environment === 'wx') {
        // eslint-disable-next-line no-underscore-dangle
        if (window.__wxjs_environment === 'miniprogram') {
          trackData.app = 'weixin_mini';
          doPoint('AppClick', trackData);
          if (this.urlData.fromType === 'qa') {
            // 小程序内部 qa来源 直接关闭h5_webview
            wx.miniProgram.navigateBack();
          } else {
            // 小程序内部 report来源 正常返回上一页
            window.history.back();
          }
        } else {
          trackData.app = '其他';
          // h5内部 全体来源 正常返回上一页
          doPoint('AppClick', trackData).finally(() => {
            window.history.back();
          });
        }
      } else if (this.environment === 'app') {
        trackData.app = '0';
        doPoint('AppClick', trackData);
        // app内部 qa来源 直接关闭webview
        if (this.urlData.fromType === 'qa') {
          try {
            window.ChunyuNativeBridge.invoke('1.0', 'back');
          } catch (err) {
            console.log(err);
            window.history.back();
          }
        } else {
          // app内部 report来源 正常返回上一页
          window.history.back();
        }
      } else {
        trackData.app = '其他';
        doPoint('AppClick', trackData).finally(() => {
          window.history.back();
        });
        // 普通h5环境 肯定是report来源 正常返回上一页
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@@/styles/mixin.scss';

.dicom-upload-main-container {
  min-height: 100vh;
  padding-top: rem(10);
  background-color: rgb(247, 247, 247);
  .section-holder {
    margin-right: rem(10);
    margin-bottom: rem(10);
    margin-left: rem(10);
    padding: rem(15);
    background-color: white;
    border-radius: rem(4);
    .title-text {
      margin-bottom: rem(10);
      color: #323232;
      font-size: rem(15);
      line-height: 1;
    }
    .report-holder {
      display: flex;
      flex-flow: row nowrap;
      align-items: stretch;
      width: 100%;
      height: rem(62);
      border: 1px solid rgba(226, 226, 226, 1);
      border-radius: 2px;
      .report-input-area {
        flex-grow: 1;
        padding: rem(10);
        .link-input {
          display: block;
          border: none;
          resize: none;
          &::placeholder {
            color: #c2c2c2;
            font-size: rem(13);
          }
          &:focus {
            outline: none;
          }
        }
      }
      .scan-button {
        display: flex;
        flex: 0 0 rem(93);
        flex-flow: column nowrap;
        align-items: center;
        align-self: stretch;
        justify-content: center;
        background: #f2fdf5;
        border-radius: 0 1px 1px 0;
        .button-icon {
          display: block;
          width: rem(14);
          height: rem(14);
          margin-bottom: rem(5);
        }
        .button-text {
          justify-content: center;
          color: #39d167;
          font-size: rem(12);
        }
      }
    }
    .choose-button-holder {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      margin-bottom: rem(12);
      line-height: 1;
      &.margin-top {
        margin-top: rem(15);
      }
      &.no-margin-bottom {
        margin-bottom: 0;
      }

      .choose-icon {
        display: block;
        width: rem(20);
        height: rem(20);
      }
      .choose-button-title {
        margin-left: rem(5);
        color: #323232;
        font-size: rem(15);
      }
      .choose-button-text {
        margin-left: rem(5);
        color: #999;
        font-size: rem(13);
      }
    }
  }
  .bottom-button-holder {
    position: fixed;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    width: 100%;
    padding: rem(10) rem(15);
    padding-bottom: calc(15px + env(safe-area-inset-bottom));
    background-color: white;
    box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.08);
    .bottom-button {
      height: rem(44);
      margin: 0 rem(15);
      color: #fff;
      font-size: rem(16);
      line-height: rem(44);
      text-align: center;
      background: #39d167;
      border-radius: 2px;
    }
  }
}
</style>
